<template>
  <div class="main-view" v-loading.body="loading">
    <el-card style="margin-bottom:20px" shadow="never">
      <el-tabs v-model="tabName" type="card" @tab-click="handleTabClick">
        <el-tab-pane label="奖励返佣" name="commission"></el-tab-pane>
      </el-tabs>
      <div class="amount-row">

        <div class="amount-cell" v-if="tabName === 'commission'">
          <div class="amount-cell-title">返佣余额</div>
          <div class="amount-cell-content">{{ profitStatistics.commission_benefitBalance || '--' }}</div>
        </div>
        <div class="amount-cell">
          <div class="amount-cell-title">发票余额</div>
          <div class="amount-cell-content">{{ tabName === 'trade' ? profitStatistics.invoiceBalance : profitStatistics[`${tabName}_invoiceBalance`] || '--' }}</div>
        </div>
        <div class="amount-cell">
          <div class="amount-cell-title">历史{{tabName !== 'commission' ? '分润' : '返佣'}}合计</div>
          <div class="amount-cell-content">{{ tabName === 'trade' ? profitStatistics.profitTotalIncome : profitStatistics[`${tabName}_profitTotalIncome`] || '--' }}</div>
        </div>
      </div>
      <div class="amount-row">
        <div class="amount-cell">
          <div class="amount-cell-title">已申请未打款</div>
          <div class="amount-cell-content">{{ tabName === 'trade' ? profitStatistics.profitApplyNoRemit : profitStatistics[`${tabName}_profitApplyNoRemit`] || '--' }}</div>
        </div>
        <div class="amount-cell">
          <div class="amount-cell-title">打款中金额</div>
          <div class="amount-cell-content">{{ tabName === 'trade' ? profitStatistics.agentloaningmoney : profitStatistics[`${tabName}_agentloaningmoney`] || '--' }}</div>
        </div>
        <div class="amount-cell">
          <div class="amount-cell-title">已补打金额</div>
          <div class="amount-cell-content">{{ tabName === 'trade' ? profitStatistics.agentadddmoney : profitStatistics[`${tabName}_agentadddmoney`] || '--' }}</div>
        </div>
        <div class="amount-cell">
          <div class="amount-cell-title">已打款合计</div>
          <div class="amount-cell-content">{{ tabName === 'trade' ? profitStatistics.profitAlreadyPickMoney : profitStatistics[`${tabName}_profitAlreadyPickMoney`] || '--' }}</div>
        </div>
        <div class="amount-cell">
          <div class="amount-cell-title">已扣款合计</div>
          <div class="amount-cell-content">{{ tabName === 'trade' ? profitStatistics.profitDeductedMoney : profitStatistics[`${tabName}_profitDeductedMoney`] || '--' }}</div>
        </div>
      </div>
      <div class="extract-amount">
        提取金额
        <el-input class="extract-amount-input" placeholder="请输入金额" v-model="extractAmount">
          <template slot="append">
            <div class="extract-all" @click="extractAmount = tabName === 'trade' ? profitStatistics.benefitBalance : profitStatistics[`${tabName}_benefitBalance`]">全部提取</div>
          </template>
        </el-input>
      </div>
      <auth-button opt="extract" @click.native="extractClick" label="确认提取"></auth-button>
      <div class="amount-row">
        <div class="tips-view" v-show="tabName == 'commission'">
          <p>注意：</p>
          <p>1. 返佣金额总额达到{{ limit }}元以上方可提取</p>
          <p>2. 提取金额后7个工作日内打款</p>
          <p>3. 返佣提取前请先提供发票，若无发票无法取出</p>
          <p>4. 建议提前邮寄发票，或保持发票余额充裕</p>
        </div>
      </div>
      <div class="amount-row" v-show="tabName == 'commission'">
        <div class="rule-button" @click="imgDialogVisible = true">分润开票规则</div>
        <div class="rule-button" @click="showRuleImg(3)">发票录入规则</div>
      </div>
    </el-card>
    <el-dialog
      @close="ruleImgUrl = ''"
      :visible.sync="imgDialogVisible"
      width="60%"
      center>
      <img style="width: 100%;" :src="ruleImgUrl" v-if="ruleImgUrl">
      <embed src="static/分润开票规则.pdf" v-else width="100%" height="600"/>
    </el-dialog>
  </div>
</template>

<script>
import qs from 'qs'
import { singleTranferPic, profitStatistics, profitPickUp, blueSeaPickUp, oasisPickUp, commissionPickUp } from '@/api/settle'
export default {
  name: 'ProfitExtract',
  components: {
  },
  data () {
    return {
      loading: false,
      profitStatistics: {},
      extractAmount: '',
      imgDialogVisible: false,
      ruleImgUrl: '',
      tabName: 'trade',
      lastTabName: 'trade',
      showPdf: false
    }
  },
  computed: {
    limit () {
      return 500
    }
  },
  mounted () {
    this.getProfitStatistics()
  },
  beforeDestroy () {},
  methods: {
    /**
     * tab切换点击
     */
    handleTabClick (tab, event) {
      if (this.lastTabName === this.tabName) return
      this.lastTabName = this.tabName
    },
    /**
     * 提取按钮点击
     */
    extractClick () {
      const name = this.tabName === 'trade' ? '' : this.tabName + '_'
      if (parseFloat(this.extractAmount) > parseFloat(this.profitStatistics[`${name}invoiceBalance`]) || parseFloat(this.extractAmount) > parseFloat(this.profitStatistics[`${name}profitBalance`])) {
        this.$message({
          message: '提取金额不能超过发票余额和分润余额',
          type: 'warning'
        })
        return
      }
      switch (this.tabName) {
        case 'trade': {
          this.pickUpProfit(this.extractAmount)
          break
        }
        case 'bluesea': {
          this.blueSeaPickUpProfit(this.extractAmount)
          break
        }
        case 'oasis': {
          this.oasisPickUpProfit(this.extractAmount)
          break
        }
        case 'commission': {
          this.commissionPickUpProfit(this.extractAmount)
          break
        }
      }
    },
    /**
     * 显示对应的提示图
     */
    showRuleImg (type) {
      let dfsPath = ''
      switch (type) {
        case 1:
          dfsPath = 'picture/M00/60/79/wKgLtFkudk2ACN2nAAFY0XyfE6Y067.jpg'
          break
        case 2:
          dfsPath = 'picture2/M00/20/27/rBQLSFx0_TmAKoMzAAPYXVYgHQc876.png'
          break
        case 3:
          dfsPath = 'picture/M00/29/59/wKgLyFnlZ16AR0rwAACHiRxozkc912.jpg'
          break
      }
      var param = {
        dfsPath: dfsPath
      }
      param = qs.stringify(param)
      singleTranferPic(param).then(response => {
        console.log('transferPic response:', response)
        if (response.error_code === '0') {
          this.ruleImgUrl = response.showPath
          this.imgDialogVisible = true
        //  alert(this.ruleImgUrl);
        } else {
          this.$message({
            message: response.error_msg,
            type: 'error'
          })
        }
      }).catch(() => {
        this.$message({
          showClose: true,
          message: '网络出小差了，请再重试一次',
          type: 'error'
        })
      })
    },
    /**
     * 获取分润统计信息
     */
    getProfitStatistics () {
      this.loading = true
      profitStatistics('').then(response => {
        this.loading = false
        console.log('getProfitStatistics response:', response)
        this.profitStatistics = response
        // 分润余额
        this.handleBenefitBalance(this.profitStatistics)
      })
    },
    /**
     * 提取接口
     */
    pickUpProfit (extractAmount) {
      this.loading = true
      profitPickUp({
        amount: extractAmount
      }).then(response => {
        this.loading = false
        console.log('pickUpProfit response:', response)
        if (response.error_code === '0') {
          this.getProfitStatistics()
          this.extractAmount = ''
          this.$message({
            message: '提取成功',
            type: 'success'
          })
        } else {
          this.$message({
            message: response.error_msg,
            type: 'error'
          })
        }
      })
    },
    /**
     * 蓝海行动提取接口
     */
    blueSeaPickUpProfit (extractAmount) {
      this.loading = true
      blueSeaPickUp({
        amount: extractAmount
      }).then(response => {
        this.loading = false
        console.log('blueSeaPickUp response:', response)
        if (response.error_code === '0') {
          this.getProfitStatistics()
          this.extractAmount = ''
          this.$message({
            message: '提取成功',
            type: 'success'
          })
        } else {
          this.$message({
            message: response.error_msg,
            type: 'error'
          })
        }
      })
    },
    /**
     * 绿洲计划提取接口
     */
    oasisPickUpProfit (extractAmount) {
      this.loading = true
      oasisPickUp({
        amount: extractAmount
      }).then(response => {
        this.loading = false
        console.log('oasisPickUpProfit response:', response)
        if (response.error_code === '0') {
          this.getProfitStatistics()
          this.extractAmount = ''
          this.$message({
            message: '提取成功',
            type: 'success'
          })
        } else {
          this.$message({
            message: response.error_msg,
            type: 'error'
          })
        }
      })
    },
    commissionPickUpProfit (extractAmount) {
      this.loading = true
      commissionPickUp({
        amount: extractAmount
      }).then(response => {
        this.loading = false
        console.log('commissionPickUpProfit response:', response)
        if (response.error_code === '0') {
          this.getProfitStatistics()
          this.extractAmount = ''
          this.$message({
            message: '提取成功',
            type: 'success'
          })
        } else {
          this.$message({
            message: response.error_msg,
            type: 'error'
          })
        }
      })
    },
    handleBenefitBalance (profitStatistics) {
      ['trade', 'bluesea', 'oasis', 'commission'].map(item => {
        if (item === 'trade') {
          profitStatistics.benefitBalance = profitStatistics.profitBalance
            ? profitStatistics.profitApplyNoRemit
              ? (profitStatistics.profitBalance - profitStatistics.profitApplyNoRemit).toFixed(2)
              : profitStatistics.profitBalance
            : '--'
        } else {
          profitStatistics[`${item}_benefitBalance`] = profitStatistics[`${item}_profitBalance`]
            ? profitStatistics[`${item}_profitApplyNoRemit`]
              ? (profitStatistics[`${item}_profitBalance`] - profitStatistics[`${item}_profitApplyNoRemit`]).toFixed(2)
              : profitStatistics[`${item}_profitBalance`]
            : '--'
        }
      })
    }
  },
  filters: {}
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@mixin flex-horizontal {
  display: -webkit-box;
  display: flex;
  display: -webkit-flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}
.main-view {
  padding: 0 0 0 16px;
  text-align: center;
}
.amount-row {
  @include flex-horizontal;
  justify-content: center;
  .amount-cell {
    width: 200px;
    padding: 30px 40px;
    .amount-cell-title {
      margin-bottom: 25px;
      font-size: 20px;
      font-weight: bold;
    }
  }
}
.extract-amount {
  @include flex-horizontal;
  justify-content: center;
  margin: 30px 0;
  .extract-amount-input {
    margin-left: 15px;
    width: 300px;
    .extract-all {
      cursor: pointer;
    }
  }
}
.tips-view {
  margin: 50px 0 20px 0;
  p {
    text-align: left;
  }
}
.rule-button {
  margin: 30px 20px;
  cursor: pointer;
  text-decoration: underline;
}
</style>
